// src/lib/pocketbase.js
import PocketBase from 'pocketbase';
import { POCKETBASE_URL } from '../config';

const pb = new PocketBase(POCKETBASE_URL);

// Recarga la autenticación desde las cookies al iniciar
pb.authStore.loadFromCookie(document.cookie);

// Escucha cambios en el estado de autenticación y guarda la cookie
pb.authStore.onChange(() => {
    console.log('Auth state changed');
    document.cookie = pb.authStore.exportToCookie({ httpOnly: false });
});

export default pb;